import { render } from "./ztn-button.vue?vue&type=template&id=2f1769f6&scoped=true"
import script from "./ztn-button.vue?vue&type=script&lang=js"
export * from "./ztn-button.vue?vue&type=script&lang=js"

import "./ztn-button.vue?vue&type=style&index=0&id=2f1769f6&scoped=true&lang=css"

import exportComponent from "/src/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@4.8.4__webpack@5.84.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1769f6"]])

export default __exports__